import React, {useRef, useEffect} from 'react';
import {Box, Typography} from '@customink/pigment-react';
import useBreakpoint from '../hooks/useBreakpoint';
import desktopPromoImage from 'images/tshirts-promo/tshirts-promo-bg.jpg';
import mobilePromoImage from 'images/tshirts-promo/tshirts-promo-bg-mobile.jpg';
import config from '../config';

export const TShirtPromoBanner = ({
  analyticsAttributes,
  isDesktopVisualFiltersEnabled = false
}) => {
  const breakpoint = useBreakpoint();
  const isMobile =
    breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md';
  const fireAnalytics = useRef(false);

  useEffect(() => {
    if (!fireAnalytics.current) {
      window.dataLayer.push({
        event: 'view_promotion',
        ecommerce: {
          creative_name: analyticsAttributes?.creative_name,
          creative_slot: 'PLP Banner',
          promotion_id: analyticsAttributes?.id,
          promotion_name: 'August 2025 Tshirt Promo'
        }
      });
      fireAnalytics.current = true;
    }
  }, []);

  const getDesktopFontSize = (breakpoint) => {
    if (isDesktopVisualFiltersEnabled && breakpoint === 'xl') {
      return '2rem';
    } else {
      if (breakpoint === 'lg') {
        return '1.25rem';
      } else {
        return '1.5rem';
      }
    }
  };

  const image = isMobile
    ? `${config.assets.imagePath}${mobilePromoImage}`
    : `${config.assets.imagePath}${desktopPromoImage}`;

  return (
    <Box
      sx={{
        width: '100%',
        height: isMobile ? '6rem' : '7.5rem',
        flexShrink: 0,
        borderRadius: '0.5rem',
        marginBottom: isMobile ? '0.5rem' : '1.72rem',
        position: 'relative', // Add position relative to the root container
        overflow: 'hidden' // Hide the overflowing parts of the blurred image
      }}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `linear-gradient(180deg, rgba(121, 42, 130, 0.6) 9.83%, #792a82 107.11%), url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          backgroundBlendMode: 'multiply',
          backgroundSize: 'cover'
        }}
      />
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
          borderRadius: '0.5rem'
        }}>
        {/* Content Wrapper */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: isMobile ? 'calc(100% - 2rem)' : '100%',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '0.25rem' : '0.75rem',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0
          }}>
          {/* Text Content */}
          {isMobile ? (
            // Mobile Layout - Vertical Stack
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.125rem',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Sharp Sans, sans-serif',
                fontWeight: 700,
                textShadow: '2px 2px 6px rgba(121, 42, 130, 0.8)',
                textAlign: 'center'
              }}>
              <Typography
                sx={{
                  fontSize: '1.125rem',
                  lineHeight: '1.25',
                  color: '#ffdc1e',
                  fontWeight: 700,
                  fontFamily: 'Sharp Sans, sans-serif',
                  letterSpacing: '-0.02rem',
                  whiteSpace: 'nowrap'
                }}>
                Save 15% on Custom Tees.
              </Typography>
              <Typography
                sx={{
                  fontSize: '1rem',
                  lineHeight: '1.25',
                  color: '#ffffff',
                  fontWeight: 700,
                  fontFamily: 'Sharp Sans, sans-serif',
                  letterSpacing: '-0.02rem',
                  whiteSpace: 'nowrap'
                }}>
                Fall Into Style! Now Through September 1.*
              </Typography>
            </Box>
          ) : (
            // Desktop Layout - Horizontal
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '0.75rem',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Sharp Sans, sans-serif',
                fontWeight: 700,
                lineHeight: '1.25',
                letterSpacing: '-0.04rem',
                textShadow: '2px 2px 6px rgba(121, 42, 130, 0.8)',
                whiteSpace: 'nowrap'
              }}>
              <Typography
                sx={{
                  fontSize: getDesktopFontSize(breakpoint),
                  lineHeight: '1.25',
                  color: '#ffdc1e',
                  fontWeight: 700,
                  fontFamily: 'Sharp Sans, sans-serif',
                  letterSpacing: '-0.04rem',
                  whiteSpace: 'nowrap'
                }}>
                Save 15% on Custom Tees.
              </Typography>

              <Typography
                sx={{
                  fontSize: getDesktopFontSize(breakpoint),
                  lineHeight: '1.25',
                  color: '#ffffff',
                  fontWeight: 700,
                  fontFamily: 'Sharp Sans, sans-serif',
                  letterSpacing: '-0.04rem',
                  whiteSpace: 'nowrap'
                }}>
                Fall Into Style! Now Through September 1.*
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
